export default "__VITE_ASSET__DhONPj7d__"